import { Frame, Page, Layout, LegacyCard, Text, Spinner, DataTable } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import api from '../../helpers/api';

const RefundDetails = () => {
    const { refundId } = useParams();
    const [refund, setRefund] = useState(null);
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        if (refundId) {
            api.getRefundDetails(refundId)
                .then((response) => {
                    setRefund(response.data.data);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [refundId]);

    return (
        <Frame>
            <Page title="Refund Details" backAction={{ content: 'Back to Refunds', onAction: () => history.push('/refunds') }}>
                <Layout>
                    <Layout.Section>
                        {loading ? (
                            <LegacyCard sectioned>
                                <Text variant="bodyMd" color="subdued" alignment="center">
                                    <Spinner size="large" accessibilityLabel="Loading refund details" />
                                </Text>
                            </LegacyCard>
                        ) : refund ? (
                            <LegacyCard title={`Refund #${refund.id}`} sectioned>
                                <Text variant="bodyMd"><strong>Employee:</strong> {refund?.shopify_user?.name}</Text>
                                <Text variant="bodyMd"><strong>Customer:</strong> {refund?.customer?.full_name ?? 'N/A'}</Text>
                                <Text variant="bodyMd"><strong>Gift Card:</strong> {refund?.gift_card?.code ? `****${refund.gift_card.code}` : 'N/A'}</Text>
                                <Text variant="bodyMd"><strong>Date Created:</strong> {new Date(refund.created_at).toLocaleString()}</Text>
                                <br></br>
                                <LegacyCard title="Refund Items" sectioned>
                                    {refund.variants && refund.variants.length > 0 ? (
                                        <>
                                            <DataTable
                                                totals={[
                                                    '',
                                                    '',
                                                    refund.variants.reduce((acc, item) => acc + item.pivot.quantity, 0),
                                                    `$${refund.variants.reduce((acc, item) => acc + parseFloat(item.pivot.return_value), 0).toFixed(2)}`,
                                                    `$${parseFloat(refund.value).toFixed(2)}`
                                                ]}
                                                showTotalsInFooter={true}
                                                columnContentTypes={["text", "text", "numeric", "numeric", "numeric"]}
                                                headings={[
                                                    <Text variant="bodyMd" fontWeight="bold">Name</Text>,
                                                    <Text variant="bodyMd" fontWeight="bold">SKU</Text>,
                                                    <Text variant="bodyMd" fontWeight="bold">Quantity</Text>,
                                                    <Text variant="bodyMd" fontWeight="bold">Value</Text>,
                                                    <Text variant="bodyMd" fontWeight="bold">Total</Text>
                                                ]}
                                                rows={refund.variants.map((item, index) => [
                                                    item.product_title,
                                                    item.sku ? item.sku : '-',
                                                    item.pivot.quantity,
                                                    `$${parseFloat(item.pivot.return_value).toFixed(2)}`,
                                                    `$${parseFloat(item.pivot.quantity * item.pivot.return_value).toFixed(2)}`
                                                ])}
                                            />
                                        </>
                                    ) : (
                                        <Text variant="bodyMd">No items in this refund.</Text>
                                    )}
                                </LegacyCard>
                            </LegacyCard>
                        ) : (
                            <LegacyCard sectioned>
                                <Text variant="bodyMd">Refund not found.</Text>
                            </LegacyCard>
                        )}
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
};

export default RefundDetails;
